import { Component, Input, forwardRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
import { FcchosenBusiness } from '../business/fcchosen.business';
/**
 * fc-choseèªå®ä¹ä¸æå¤é
 * 
 * åä¸å¼¹åºçåè¡¨ï¼ä½åæ¶å¯ä»¥å¤éã
 * 
 * å¼¹åºä¸ä¸ªä¸æèåç»ç¨æ·éæ©æä½ï¼ç¨äºä»£æ¿åççéæ©å¨ï¼æèéè¦ä¸ä¸ªæ´ä¼éçå¤éå¨æ¶ãéä¸­çæ¯ä¸ä¸ªå¼ã
 * 
 * äºä»¶ï¼
 * 
 * 1.æ¸é¤äºä»¶ï¼clear
 * 
 */
@Component({
    selector: 'fc-chosen',
    template: `
    <nz-select  [nzFilterOption]="fcFilterOption" [nzDropdownClassName]="fcDropdownClassName" [nzDropdownStyle]="fcDropdownStyle" 
    class="fc-chosen" *ngIf="fcShowLabel==='N'" [ngClass]="{'fc-readonly':_readonly===true,'fc-chosen-small':fcSize === 'small','fc-chosen-default':fcSize === 'default','fc-chosen-large':fcSize === 'large'}"
         [nzShowSearch]="fcShowSearch"  (nzOnSearch)="_event('onSearch',$event)" (nzOpenChange)="_event('openChange',$event)" (nzScrollToBottom)="_event('scrollToBottom',$event)"  
          [nzDisabled]="_disabled" [(ngModel)]="_selectOptions" [nzMode]="fcType" [nzSize]="fcSize" 
         (ngModelChange)="_event('valueOnChange',$event)" [nzNotFoundContent]="fcNotFoundContent" [nzPlaceHolder]="fcPlaceHolder" 
         [nzAllowClear]="_allowClear" [nzDropdownMatchSelectWidth]="_autoSize" [nzOpen]="_open" [nzAutoFocus]="fcAutoFocus==='Y'">
        <nz-option *ngFor="let option of _options" (click)="_event('click',option)"  [nzLabel]="option.label" [nzValue]="option.value" [nzDisabled]="option.disabled"></nz-option>
        <nz-option *ngIf="fcLoading==='Y'" nzDisabled nzCustomContent>
        <i nz-icon type="loading" class="loading-icon"></i> æ­£å¨å è½½ä¸­...
      </nz-option>
    </nz-select>
    <div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
        <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
        <div nz-col [nzSpan]="valueSpan">
            <nz-select  [nzFilterOption]="fcFilterOption" [nzDropdownClassName]="fcDropdownClassName" 
            [nzDropdownStyle]="fcDropdownStyle" class="fc-chosen" [nzSize]="fcSize" [ngClass]="{'fc-readonly':_readonly===true}" [nzDisabled]="_disabled" 
                [nzShowSearch]="fcShowSearch" (nzOpenChange)="_event('openChange',$event)"
                 (nzOnSearch)="_event('onSearch',$event)" (nzScrollToBottom)="_event('scrollToBottom',$event)"  [(ngModel)]="_selectOptions" [nzMode]="fcType" 
                 (ngModelChange)="_event('valueOnChange',$event)" 
                [nzNotFoundContent]="fcNotFoundContent" [nzPlaceHolder]="fcPlaceHolder" 
                [nzAllowClear]="_allowClear" [nzDropdownMatchSelectWidth]="_autoSize" [nzOpen]="_open" [nzAutoFocus]="fcAutoFocus==='Y'">
                <nz-option *ngFor="let option of _options" (click)="_event('click',option)"  [nzLabel]="option.label" [nzValue]="option.value" [nzDisabled]="option.disabled"></nz-option>
                <nz-option *ngIf="fcLoading==='Y'" nzDisabled nzCustomContent>
                <i nz-icon type="loading" class="loading-icon"></i> æ­£å¨å è½½ä¸­...
                </nz-option>
            </nz-select>
            <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
                {{fcHelp}}
            </div>
            <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
                <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.required}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
                </div>
            </div>
        </div>
    </div>
  `,
    styles: [`
        
        :host ::ng-deep .ant-select-dropdown{
            overflow:auto;
        }
        .fc-chosen{
            width:100%
        }
        :host ::ng-deep .ant-select-dropdown-menu-item{
            overflow: visible;
        }
        .fc-readonly {
            pointer-events: none;
        }
        :host ::ng-deep .fc-readonly .ant-select-selection{
            background-color: #f5f5f5;
        }
        .form-explain {
            position:relative;
        }
        .explain{
            white-space: nowrap;
            position:absolute;
            right: -1px;
            bottom: 24px;
            z-index:10;
        }
        .explain-inner {
            position:relative;
            color:red;
        }
        .explain-inner:after{
            content: '';
            width: 10px;
            height: 12px;
            display: block;
            background-color: #ffffff;
            border-right: 1px solid #e9e9e9;
            border-bottom: 1px solid #e9e9e9;
            position: absolute;
            bottom: -6px;
            right: 12px;
            transform: rotate(45deg);
            z-index: 0;
        }
        .explain-tips{
            padding: 0px 10px;
            background-color: #ffffff;
            border: 1px solid #e9e9e9;
            border-radius: 4px;
            font-size: 12px;
            height: 30px;
            line-height: 28px;
        }
    `],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FcchosenComponent),
        multi: true
    }]
})
export class FcchosenComponent extends FcinputComponent {
    @Input()
    fcFilterOption: Function;
    @Input()
    fcDropdownClassName: string;
    @Input()
    fcDropdownStyle: string;
    // é¦è¡ç©ºè¡
    @Input()
    fcLineOneSpace: string;
    /*æ¯å¦loading */
    @Input()
    fcLoading = 'N';
    /** æç¤º*/
    @Input()
    fcToolTip: string;
    /** åéå¼*/
    @Input()
    fcOption: any[];
    _options: any[] = [];
    _selectOptions: string[];
    /** æ¯å¦å¯ç¨æç´¢*/
    @Input()
    fcShowSearch: boolean = true;
    /** å½ä¸æåè¡¨ä¸ºç©ºæ¶æ¾ç¤ºçåå®¹*/
    @Input()
    fcNotFoundContent: string;
    /**labelå­æ®µåç§°*/
    @Input()
    fcLabelCode: string;
    /**valueå­æ®µåç§°*/
    @Input()
    fcValueCode: string;
    /**disabledå­æ®µåç§°*/
    @Input()
    _disabledCode: string;
    /**æ¯å¦æ¯ææ¸é¤*/
    @Input()
    fcAllowClear: string;
    _allowClear: boolean;
    /**åå®¹ç­å®½*/
    @Input()
    fcAutoSize: string;
    _autoSize: boolean;

    @Input()
    fcAutoFocus: string;
    /**æ¯å¦æå¼ä¸æ*/
    @Input()
    fcOpen: string;
    _open: boolean;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-chosen');
        FcchosenBusiness.initData(this, {});
    }
    _afterParentInit(param) {
        if ((param && Object.keys(param).length === 0) || !param) {
            // çæ§æ¯å¦åçå¼åå
            FcchosenBusiness.valueChange(this, param);
            return;
        }
        FcchosenBusiness.changeOption(this, param);
        /**æ¯å¦æ¯ææ¸é¤*/
        this._allowClear = this.fcAllowClear === undefined || this.fcAllowClear === "Y";
        /**åå®¹ç­å®½*/
        this._autoSize = this.fcAutoSize !== 'N';
        /**æ¯å¦æå¼ä¸æ*/
        this._open = this.fcOpen === 'Y';
        /**æ¯å¦ç¦ç¨*/
        this._disabled = this.fcDisabled === 'Y';
        /**æ¯å¦åªè®*/
        this._readonly = this.fcReadonly === 'Y';
        FcchosenBusiness.valueChange(this, param);
    }
    _event(eventName, $event) {
        switch (eventName) {
            case 'scrollToBottom':
                super.event('scrollToBottom', this._selectOptions);
                break;
            case 'valueOnChange':
                FcchosenBusiness.valueOnChange(this, $event);
                break;
            default:
                super.event(eventName, $event);
        }
    }

}


